import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/material/styles";

import { ZINDEX_MESSAGE } from "../Theme";

export const StyledDialog = styled(Dialog)({
    zIndex: ZINDEX_MESSAGE,
    fontFamily: "Noto Sans JP, sans-serif",
    "& .MuiDialogTitle-root": {
        fontFamily: "Noto Sans JP, sans-serif",
    },
    "& .MuiDialogContent-root": {
        fontFamily: "Noto Sans JP, sans-serif",
    },
    "& .MuiDialogActions-root": {
        fontFamily: "Noto Sans JP, sans-serif",
    },
});
